module.exports = __webpack_public_path__ + "static/media/4.18336d11.png";